module.exports = {
	"id": "MV",
	"name": "Maldives",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": 0.019395,
			"11": 0.011637,
			"12": 0.031032,
			"13": null,
			"14": null,
			"15": null,
			"16": 0.007758,
			"17": 0.007758,
			"18": null,
			"19": 0.015516,
			"20": null,
			"21": 0.027153,
			"22": null,
			"23": 0.031032,
			"24": null,
			"25": 0.007758,
			"26": 0.011637,
			"27": 0.003879,
			"28": 0.007758,
			"29": 0.019395,
			"30": 0.023274,
			"31": 0.042669,
			"32": 0.015516,
			"33": 0.027153,
			"34": 0.042669,
			"35": 0.007758,
			"36": 0.062064,
			"37": null,
			"38": 0.027153,
			"39": 0.027153,
			"40": 0.015516,
			"41": 0.011637,
			"42": 0.031032,
			"43": 0.11637,
			"44": 0.027153,
			"45": 0.034911,
			"46": 0.027153,
			"47": 0.046548,
			"48": 0.325836,
			"49": 0.453843,
			"50": 0.128007,
			"51": 0.263772,
			"52": 0.287046,
			"53": 17.315856,
			"54": 4.515156,
			"55": 0.073701,
			"56": 0.019395,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.007758,
			"4": 0.011637,
			"5": null,
			"6": null,
			"7": 0.003879,
			"8": 0.015516,
			"9": null,
			"10": 0.007758,
			"11": null,
			"12": 0.019395,
			"13": 0.011637,
			"14": null,
			"15": 0.007758,
			"16": 0.003879,
			"17": null,
			"18": 0.007758,
			"19": 0.007758,
			"20": 0.003879,
			"21": 0.003879,
			"22": 0.007758,
			"23": 0.003879,
			"24": 0.003879,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.011637,
			"30": 0.027153,
			"31": null,
			"32": 0.023274,
			"33": 0.007758,
			"34": 0.011637,
			"35": 0.019395,
			"36": 0.003879,
			"37": 0.023274,
			"38": 0.027153,
			"39": 0.031032,
			"40": 0.015516,
			"41": 0.023274,
			"42": 0.081459,
			"43": 0.128007,
			"44": 0.162918,
			"45": 0.108612,
			"46": 0.046548,
			"47": 0.321957,
			"48": 0.3879,
			"49": 4.061313,
			"50": 0.500391,
			"51": null,
			"52": 0.003879,
			"3.5": null,
			"3.6": 0.007758
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": 0.003879,
			"17": null,
			"18": null,
			"19": null,
			"20": 0.003879,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": 0.027153,
			"35": null,
			"36": null,
			"37": 0.143523,
			"38": 0.003879,
			"39": 0.003879,
			"40": 0.267651,
			"41": 0.023274,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.007758
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": null,
			"6": 0.003879,
			"7": 0.011637,
			"8": 0.058185,
			"9": 0.058185,
			"10": 0.729252,
			"3.1": null,
			"3.2": null,
			"5.1": 0.011637,
			"6.1": 0.007758,
			"7.1": null,
			"9.1": 0.298683
		},
		"ios_saf": {
			"8": 0,
			"10": 6.46892355204,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.174330004371,
			"8.1-8.4": 0.322067296211,
			"9.0-9.2": 0.153646783514,
			"9.3": 2.34409836386
		},
		"android": {
			"3": 0,
			"4": 0.0715223824289,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00894029780362,
			"4.1": 0.257991450904,
			"4.2-4.3": 0.644978627261,
			"4.4": 1.4789806938,
			"4.4.3-4.4.4": 1.4917525478
		},
		"ie": {
			"6": 0.00806075121951,
			"7": null,
			"8": 0.100759390244,
			"9": 0.032243004878,
			"10": 0.523948829268,
			"11": 0.66904235122,
			"5.5": null
		},
		"op_mob": {
			"0": 0.407346139175,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0113151705326
		},
		"edge": {
			"12": 0.089217,
			"13": 0.170676,
			"14": 0.337473
		},
		"ie_mob": {
			"10": 0.057933971831,
			"11": 0.235874028169
		},
		"bb": {
			"7": 0.00153025,
			"10": null
		},
		"samsung": {
			"0": 4.670323
		},
		"and_uc": {
			"0": 5.453811
		},
		"op_mini": {
			"0": 5.48810369029
		},
		"and_chr": {
			"0": 35.109267
		},
		"and_ff": {
			"0": 0.091815
		}
	},
	"total": 98.8738425768
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/MV.json
 ** module id = 599
 ** module chunks = 0
 **/